var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { MasterKeyRequest, MasterKeyRequestType } from "@/share/MasterKeyReq";
import { action, makeObservable, observable } from "mobx";
import { Router } from "./Router";
import { FileDownloadType } from "@/share/FileRequest";
import { DownloadQueueItem } from "./DownloadQueueItem";
export class AppHeaderStore {
    constructor() {
        this.menuopen = false;
        this.showverify = false;
        this.verifydays = 7;
        this.adminview = false;
        this.usedspace = 0;
        this.usedmspace = 0;
        this.useduser = 0;
        this.showspacemenu = false;
        this.pendingbill = false;
        this.showedwarning = false;
        this.initialadminview = true;
        this.zindex = 10;
        this.queuedItems = [];
        this.showdownloadqueue = false;
        this.adminQueuedItems = [];
        this.showadmindownloadqueue = false;
        makeObservable(this);
        APPEvent.addSubscriberForMasterKeyResponse((res) => {
            if (this.adminview && !res.masterkey && !res.hasKey) {
                if (!this.showedwarning) {
                    this.showedwarning = true;
                    APPEvent.publishApperror("Looks like you havent saved master key on letrwing. Please add master key to access admin features. You can add master key by clicking on your name on top right side.");
                }
            }
        });
        APPEvent.addSubscriberForQuota((qt) => {
            this.setQuota(qt);
        });
        APPEvent.addSubscriberForIsAdmin((admin) => {
            if (this.initialadminview && admin) {
                const router = Router.getActiveRoute();
                if (router && router.tab === "Admin") {
                    this.setAdminView(true, true);
                }
            }
            this.initialadminview = false;
        });
        APPEvent.addSubscriberForOrgverificationDetail((det) => {
            const sevenday = det.creationtime + (7 * 24 * 60 * 60 * 1000);
            const today = new Date().getTime();
            if (sevenday < today) {
                this.setVerifyDays(-1);
            }
            else {
                const diff = sevenday - today;
                const days = Math.ceil(diff / (24 * 1000 * 3600));
                this.setVerifyDays(days);
            }
            this.setShowVerify(!det.verified);
        });
        APPEvent.addSubscriberForDownload((res) => {
            if (res.requesttype === FileDownloadType.Download) {
                let item = undefined;
                for (let i = 0; i < this.queuedItems.length; i++) {
                    const qitem = this.queuedItems[i];
                    if (qitem.queuid === res.queueid) {
                        item = qitem;
                        break;
                    }
                }
                if (item !== undefined) {
                    if (res.inqueue !== undefined && res.inqueue) {
                        item.setInQueue(true);
                    }
                    else {
                        item.setInQueue(false);
                    }
                    if (res.downloadfailed) {
                        item.errorDownloading(true);
                        item.setDownloading(false);
                    }
                    else if (res.downloadpath !== undefined) {
                        this.removeFromDownloadQueue(item);
                        item.setDownloading(false);
                    }
                    else if (res.progress !== undefined) {
                        item.setDownloadProgress(res.progress);
                    }
                }
            }
        });
        APPEvent.addSubscriberForAdminDownload((res) => {
            if (res.requesttype === FileDownloadType.Download) {
                let item = undefined;
                for (let i = 0; i < this.adminQueuedItems.length; i++) {
                    const qitem = this.adminQueuedItems[i];
                    if (qitem.queuid === res.queueid) {
                        item = qitem;
                        break;
                    }
                }
                if (item !== undefined) {
                    if (res.inqueue !== undefined && res.inqueue) {
                        item.setInQueue(true);
                    }
                    else {
                        item.setInQueue(false);
                    }
                    if (res.downloadfailed) {
                        item.errorDownloading(true);
                        item.setDownloading(false);
                    }
                    else if (res.downloadpath !== undefined) {
                        this.removeFromAdminDownloadQueue(item);
                        item.setDownloading(false);
                    }
                    else if (res.progress !== undefined) {
                        item.setDownloadProgress(res.progress);
                    }
                }
            }
        });
    }
    setShowDownloadQueueItemView(show) {
        this.showdownloadqueue = show;
    }
    toggleMenu() {
        this.setMenuState(!this.menuopen);
    }
    setShowVerify(ver) {
        this.showverify = ver;
    }
    setshowspacemenu(show) {
        this.showspacemenu = show;
    }
    setVerifyDays(days) {
        this.verifydays = days;
    }
    setQuota(qu) {
        this.usedmspace = qu.usedmetaspace;
        this.usedspace = qu.totalspace;
        this.useduser = qu.totalusers;
        this.pendingbill = qu.pendingbill;
    }
    setMenuState(state) {
        this.menuopen = state;
        if (this.menuopen) {
            Apphandler.sendMessage("isadmin", "");
        }
    }
    upgradeSession() {
        const req = new MasterKeyRequest();
        req.type = MasterKeyRequestType.Has;
        Apphandler.sendMessage('masterkey', req);
    }
    setAdminView(view, showinline = false) {
        if (view && !showinline) {
            const loc = window.location;
            let href = loc.href;
            if (loc.hash) {
                href = href.replace(loc.hash, "");
            }
            window.open(href + "#~~Admin", "letrwing_admin");
            return;
        }
        this.adminview = view;
        if (view) {
            Router.setAdminView();
            window.name = "letrwing_admin";
        }
        else {
            Router.clearAdminView();
            window.name = "letrwing_user";
        }
        this.showedwarning = false;
    }
    reset() {
        this.setAdminView(false);
        this.setMenuState(false);
    }
    getNextZIndex() {
        this.zindex = this.zindex + 1;
        return this.zindex;
    }
    decrementZIndex() {
        console.log('decrementing');
        this.zindex = this.zindex - 1;
        console.log('decrementing ' + this.zindex);
    }
    setShowAdminDownloadQueueItemView(show) {
        this.showadmindownloadqueue = show;
    }
    addToDownloadQueue(documentid, item) {
        this.queuedItems.push(item);
    }
    removeFromDownloadQueue(item) {
        for (let i = 0; i < this.queuedItems.length; i++) {
            const qitem = this.queuedItems[i];
            if (qitem.queuid === item.queuid) {
                item = qitem;
                this.queuedItems.splice(i, 1);
                break;
            }
        }
    }
    addToAdminDownloadQueue(documentid, item) {
        this.adminQueuedItems.push(item);
    }
    removeFromAdminDownloadQueue(item) {
        for (let i = 0; i < this.adminQueuedItems.length; i++) {
            const qitem = this.adminQueuedItems[i];
            if (qitem.queuid === item.queuid) {
                item = qitem;
                this.adminQueuedItems.splice(i, 1);
                break;
            }
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "menuopen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "showverify", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "verifydays", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "adminview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "usedspace", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "usedmspace", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "useduser", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "showspacemenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "pendingbill", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AppHeaderStore.prototype, "zindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AppHeaderStore.prototype, "queuedItems", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AppHeaderStore.prototype, "showdownloadqueue", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AppHeaderStore.prototype, "adminQueuedItems", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AppHeaderStore.prototype, "showadmindownloadqueue", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setShowDownloadQueueItemView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setShowVerify", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setshowspacemenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setVerifyDays", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setQuota", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setMenuState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setAdminView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "getNextZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "decrementZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "setShowAdminDownloadQueueItemView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, DownloadQueueItem]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "addToDownloadQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DownloadQueueItem]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "removeFromDownloadQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, DownloadQueueItem]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "addToAdminDownloadQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DownloadQueueItem]),
    __metadata("design:returntype", void 0)
], AppHeaderStore.prototype, "removeFromAdminDownloadQueue", null);
